import React from 'react';
import { Tooltip, Typography } from '@mui/material';

export interface IOpportunityBadgeProps {
  opportunityId?: string | null;
  opportunityName?: string | null;
  hasOpportunities?: boolean;
}

export const OpportunityBadge: React.FC<IOpportunityBadgeProps> = ({
  opportunityId,
  opportunityName,
  hasOpportunities,
}) => {
  if (!opportunityId || !hasOpportunities) {
    return null;
  }

  return (
    <Tooltip
      arrow
      enterDelay={400}
      enterNextDelay={400}
      title={opportunityName || 'Deal'}
    >
      <Typography
        fontSize={'10px'}
        fontWeight={500}
        className="flex items-center justify-center px-1 h-4 text-white rounded bg-sky-700 cursor-default"
      >
        Deal
      </Typography>
    </Tooltip>
  );
};
